import classnames from 'classnames/bind'
import Button from 'components/button'
import ButtonGroup from 'components/button_group'
import TabGroup from 'components/tab_group'
import TabPanel from 'components/tab_panel'
import Pagination, { INITIAL_PAGE } from 'entities/pagination'
import RecruiterCandidateDestination from 'entities/user_notice/recruiter_destination_candidate'
import SpecialCandidateDestination from 'entities/user_notice/special_destination_candidate'
import TagCandidateDestination from 'entities/user_notice/tag_destination_candidate'
import { cloneDeep, noop } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Modal from 'react-overlays/lib/Modal'
import { setModalStyle } from 'supports/modal_style_helper'
import RecruiterList from './recruiter_list'
import styles from './selection_modal.module.scss'
import SpecialList from './special_list'
import TagList from './tag_list'

const cx = classnames.bind(styles)
export default class SelectionModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedTabIndex: 0,
      temporaryRecruiterIds: props.recruiterIds,
      temporaryTagIds: props.tagIds,
      temporarySpecialTypes: props.specialTypes
    }
  }

  componentDidUpdate() {
    // re-queues the setModalStyle at the end of the execution queue
    setTimeout(() => setModalStyle(this.modal, true), 0)
  }

  handleSwitchTabIndex(index) {
    this.setState({
      selectedTabIndex: index
    })

    const { onChangeRecruitersPage, onChangeTagsPage } = this.props
    onChangeRecruitersPage(INITIAL_PAGE)
    onChangeTagsPage(INITIAL_PAGE)
  }

  confirmUpdateSelection(target) {
    const { selectedTabIndex, temporaryRecruiterIds, temporaryTagIds, temporarySpecialTypes } = this.state

    if (selectedTabIndex !== 0 && temporaryRecruiterIds.length > 0) {
      if (
        // eslint-disable-next-line no-alert
        !window.confirm(
          I18n.t('components.destinations_field.selection_modal.confirm_update_selection.attention.recruiter', {
            target
          })
        )
      ) {
        return false
      }
    }

    if (selectedTabIndex !== 1 && temporaryTagIds.length > 0) {
      if (
        // eslint-disable-next-line no-alert
        !window.confirm(
          I18n.t('components.destinations_field.selection_modal.confirm_update_selection.attention.tag', { target })
        )
      ) {
        return false
      }
    }

    if (selectedTabIndex !== 2 && temporarySpecialTypes.length > 0) {
      if (
        // eslint-disable-next-line no-alert
        !window.confirm(
          I18n.t('components.destinations_field.selection_modal.confirm_update_selection.attention.destination', {
            target
          })
        )
      ) {
        return false
      }
    }

    return true
  }

  handleUpdateSelectRecruiterIds(recruiterIds) {
    if (!this.confirmUpdateSelection(I18n.t('components.destinations_field.selection_modal.target.recruiter'))) {
      return
    }

    this.setState({
      temporaryRecruiterIds: recruiterIds,
      temporaryTagIds: [],
      temporarySpecialTypes: []
    })
  }

  handleUpdateSelectTagIds(tagIds) {
    if (!this.confirmUpdateSelection(I18n.t('components.destinations_field.selection_modal.target.tag'))) {
      return
    }

    this.setState({
      temporaryRecruiterIds: [],
      temporaryTagIds: tagIds,
      temporarySpecialTypes: []
    })
  }

  handleUpdateSelectSpecialTypes(specialTypes) {
    if (!this.confirmUpdateSelection(I18n.t('components.destinations_field.selection_modal.target.destination'))) {
      return
    }

    this.setState({
      temporaryRecruiterIds: [],
      temporaryTagIds: [],
      temporarySpecialTypes: specialTypes
    })
  }

  handleFinishSelection() {
    const { temporaryRecruiterIds, temporaryTagIds, temporarySpecialTypes } = this.state
    const { onFinishSelection, onChangeRecruitersPage, onChangeTagsPage } = this.props

    onFinishSelection(cloneDeep(temporaryRecruiterIds), cloneDeep(temporaryTagIds), cloneDeep(temporarySpecialTypes))
    onChangeRecruitersPage(INITIAL_PAGE)
    onChangeTagsPage(INITIAL_PAGE)
  }

  handleCancelSelection() {
    const { selectedTabIndex } = this.state
    const {
      recruiterIds,
      tagIds,
      specialTypes,
      onCancelSelection,
      onChangeRecruitersPage,
      onChangeRecruitersKeyword,
      onChangeTagsPage,
      onChangeTagsKeyword
    } = this.props

    let tabIndex = selectedTabIndex
    tabIndex = recruiterIds.length > 0 ? 0 : tabIndex
    tabIndex = tagIds.length > 0 ? 1 : tabIndex
    tabIndex = specialTypes.length > 0 ? 2 : tabIndex

    this.setState({
      selectedTabIndex: tabIndex,
      temporaryRecruiterIds: recruiterIds,
      temporaryTagIds: tagIds,
      temporarySpecialTypes: specialTypes
    })

    onCancelSelection()
    onChangeRecruitersPage(INITIAL_PAGE)
    onChangeRecruitersKeyword(null)
    onChangeTagsPage(INITIAL_PAGE)
    onChangeTagsKeyword(null)
  }

  render() {
    const { selectedTabIndex, temporaryRecruiterIds, temporaryTagIds, temporarySpecialTypes } = this.state
    const {
      isOpened,
      recruiters,
      recruitersPagination,
      tags,
      tagsPagination,
      specials,
      isLoadingRecruiters,
      isLoadingTags,
      isLoadingSpecials,
      onCancelSelection,
      onChangeRecruitersPage,
      onChangeRecruitersKeyword,
      onChangeTagsPage,
      onChangeTagsKeyword
    } = this.props

    const cancelButton = (
      <Button className={styles.cancelButton} intent="default" onClick={() => this.handleCancelSelection()}>
        {I18n.t('components.destinations_field.selection_modal.cancel')}
      </Button>
    )

    const completeButton = (
      <Button
        className={styles.submitButton}
        disabled={
          (selectedTabIndex === 0 && temporaryRecruiterIds.length === 0) ||
          (selectedTabIndex === 1 && temporaryTagIds.length === 0)
        }
        intent="primary"
        raised
        onClick={() => this.handleFinishSelection()}
      >
        {I18n.t('components.destinations_field.selection_modal.add_to_destination')}
      </Button>
    )

    return (
      <Modal show={isOpened} onShow={() => setModalStyle(this.modal, true)}>
        <div className={styles.modal}>
          <div className={styles.modalBg} role="presentation" onClick={onCancelSelection} />
          <div
            className={styles.modalContent}
            ref={ref => {
              this.modal = ref
            }}
          >
            <div className={styles.tabs}>
              <ButtonGroup
                className={styles.buttonGroup}
                selectedKey={selectedTabIndex}
                onSwitch={index => this.handleSwitchTabIndex(index)}
              >
                <Button
                  className={cx(styles.buttonTab, {
                    buttonTabActive: selectedTabIndex === 0
                  })}
                  intent="none"
                  disabled={selectedTabIndex === 0}
                >
                  {I18n.t('components.destinations_field.selection_modal.button.recruiter_list')}
                </Button>
                <Button
                  className={cx(styles.buttonTab, {
                    buttonTabActive: selectedTabIndex === 1
                  })}
                  intent="none"
                  disabled={selectedTabIndex === 1}
                >
                  {I18n.t('components.destinations_field.selection_modal.button.tag_list')}
                </Button>
                <Button
                  className={cx(styles.buttonTab, {
                    buttonTabActive: selectedTabIndex === 2
                  })}
                  intent="none"
                  disabled={selectedTabIndex === 2}
                >
                  {I18n.t('components.destinations_field.selection_modal.button.special')}
                </Button>
              </ButtonGroup>
              <TabGroup className="destination-tab-group" selectedIndex={selectedTabIndex}>
                <TabPanel className="destination-tab-panel">
                  <RecruiterList
                    isLoading={isLoadingRecruiters}
                    recruiters={recruiters}
                    pagination={recruitersPagination}
                    recruiterIds={temporaryRecruiterIds}
                    cancelButton={cancelButton}
                    completeButton={completeButton}
                    onChangePage={onChangeRecruitersPage}
                    onChangeKeyword={onChangeRecruitersKeyword}
                    onUpdateSelection={recruiterIds => this.handleUpdateSelectRecruiterIds(recruiterIds)}
                  />
                </TabPanel>
                <TabPanel className="destination-tab-panel">
                  <TagList
                    isLoading={isLoadingTags}
                    tags={tags}
                    pagination={tagsPagination}
                    tagIds={temporaryTagIds}
                    cancelButton={cancelButton}
                    completeButton={completeButton}
                    onChangePage={onChangeTagsPage}
                    onChangeKeyword={onChangeTagsKeyword}
                    onUpdateSelection={tagIds => this.handleUpdateSelectTagIds(tagIds)}
                  />
                </TabPanel>
                <TabPanel className="destination-tab-panel">
                  <SpecialList
                    isLoading={isLoadingSpecials}
                    specials={specials}
                    specialTypes={temporarySpecialTypes}
                    cancelButton={cancelButton}
                    completeButton={completeButton}
                    onChangePage={noop}
                    onUpdateSelection={specialTypes => this.handleUpdateSelectSpecialTypes(specialTypes)}
                  />
                </TabPanel>
              </TabGroup>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

SelectionModal.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  recruiterIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  tagIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  specialTypes: PropTypes.arrayOf(PropTypes.string),
  recruiters: PropTypes.arrayOf(PropTypes.instanceOf(RecruiterCandidateDestination)).isRequired,
  recruitersPagination: PropTypes.instanceOf(Pagination).isRequired,
  tags: PropTypes.arrayOf(PropTypes.instanceOf(TagCandidateDestination)).isRequired,
  tagsPagination: PropTypes.instanceOf(Pagination).isRequired,
  specials: PropTypes.arrayOf(PropTypes.instanceOf(SpecialCandidateDestination)),
  isLoadingRecruiters: PropTypes.bool.isRequired,
  isLoadingTags: PropTypes.bool.isRequired,
  isLoadingSpecials: PropTypes.bool,
  onFinishSelection: PropTypes.func.isRequired,
  onCancelSelection: PropTypes.func.isRequired,
  onChangeRecruitersPage: PropTypes.func.isRequired,
  onChangeRecruitersKeyword: PropTypes.func.isRequired,
  onChangeTagsPage: PropTypes.func.isRequired,
  onChangeTagsKeyword: PropTypes.func.isRequired
}

SelectionModal.defaultProps = {
  specialTypes: [],
  specials: [],
  isLoadingSpecials: false
}
